import React, { useEffect, useState } from "react";
import { matchQuest, no, userBalance, yes } from "../Redux/GetSlice";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import logo4 from "../Assets/Images/fav1.png";
import { betRes } from "../Redux/PostSlice";
import Footer from "../Components/Footer";
import discountImg from "../Assets/Images/discount5.png";
import stock from "../Assets/Images/stockup.png";
import { io } from "socket.io-client";
import { RT_BASE_URL, produc } from "../Redux/Helper";
import toast from "react-hot-toast";
import { getQuestByMarket } from "../Redux/GetSlice";
import { BASE_APP_URL } from "../config";
import { HiArrowLeft } from "react-icons/hi2";
import { CiWallet } from "react-icons/ci";
import { IoMdAdd } from "react-icons/io";
import { RiDiscountPercentFill } from "react-icons/ri";
import { FaInfo } from "react-icons/fa6";
import InfoPopup from "../Components/InfoPopup";
const socket = io.connect(RT_BASE_URL);

export default function Markets() {
  const { marketQuestions } = useSelector((state) => state.Get);
  const { Balance, totalBalanceResponse } = useSelector((state) => state.Get);
  const balanceAmount =
  parseFloat(totalBalanceResponse?.user?.balance_deposit) +
  parseFloat(totalBalanceResponse?.user?.balance_winning);
  const params = useParams();

  const [queId, setQuiId] = useState("");
  const [info, setInfo] = useState(false);
  const [popinfo, setPopinfo] = useState({});
  const [copy, setCopy] = useState(false);
  const [realQuest, setRealQuest] = useState([{}]);

  if (copy) {
    toast.success("Copied to clipboard");
    setCopy(false);
  }

  const uid = localStorage.getItem("user_id");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const infoPop = (items, ind) => {
    setInfo(true);
    setPopinfo(items);
  };

  const setYes = (mId, qId, opt) => {
    dispatch(yes());
    navigate(`/placebetmarkets/${mId}/${qId}`);
  };

  const setNo = (mId, qId, opt) => {
    dispatch(no());

    navigate(`/placebetmarkets/${mId}/${qId}`);
  };

  useEffect(() => {
    dispatch(userBalance(uid));
  }, []);

  useEffect(() => {
    setRealQuest(marketQuestions);
  }, [marketQuestions]);

  useEffect(() => {
    socket.on("newQuestionPublished", (data) => {
      let socketData = JSON.parse(data);
      if (
        socketData?.match?.match_type == "Market" &&
        socketData?.match?.market_id == params.id
      ) {
        realQuest.push(socketData);
        dispatch(getQuestByMarket(params.id));
      }
    });
  }, []);

  useEffect(() => {
    socket.on("questionDeleted", (data) => {
      let socketData = JSON.parse(data);
      if (
        socketData?.match?.match_type == "Market" &&
        socketData?.match?.market_id == params.id
      ) {
        dispatch(getQuestByMarket(params.id));
      }
    });
  }, []);

  const link = (qid) => {
    let newLink = BASE_APP_URL + `placebetmarkets/${params.id}` + `/${qid}`;
    return newLink;
  };

  useEffect(() => {
    dispatch(getQuestByMarket(params?.id));
  }, []);

  useEffect(() => {
    dispatch(matchQuest(params.id));
  }, []);

  let time = setTimeout(() => {
    setQuiId(queId + 1);
  }, 1000);

  if (queId > 2) {
    clearTimeout(time);
  }

  useEffect(() => {
    dispatch(betRes(false));
  }, [dispatch]);
  useEffect(() => {
    info && (document.body.style.overflow = "hidden");
    !info && (document.body.style.overflow = "unset");
  }, [info]);

  return (
    <div>
      <div>
        <div
          style={{ minHeight: "100vh", background: "white" }}
          className="mobile__layout main"
        >
          <div
            style={{ background: "white" }}
            className="container auth__container"
          >
            <div
              style={{
                justifyContent: "space-between",
                position: "sticky",
                top: "0",
                height: "56px",
              }}
              className="reg-back fixed_up"
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div style={{ background: "#00000000" }} className="reg__back">
                  <Link to="/">
                    <HiArrowLeft color="white" size={25} />
                  </Link>
                </div>
                Markets
              </div>

              <div
                onClick={() => navigate("/addmoney")}
                style={{
                  display: "flex",
                  justifyContent: "space-evenly",
                  alignItems: "center",
                  padding: "6px",
                  gap: "8px",
                  borderRadius: "10px",
                  background: "#202b3d",
                  fontWeight: "bold",
                  fontSize: "12px",
                }}
              >
                <CiWallet size={19} color="white" />₹{balanceAmount}
                <div
                  style={{
                    background: "green",
                    padding: "1px",
                    height: "20px",
                    borderRadius: "50px",
                  }}
                >
                  <IoMdAdd
                    style={{ margin: "auto" }}
                    size={18}
                    color="#cdcdcd"
                  />
                </div>
              </div>
            </div>

            <div
              style={{
                width: "98%",
                margin: "auto",
                height: "30px",
                display: "flex",
                alignItems: "center",
                marginTop: "5px",
                marginBottom: "8px",
                gap: "1px",
              }}
            >
              <img
                style={{ width: "30%", marginTop: "20px" }}
                src={discountImg}
                alt=""
              />

              <div
                style={{
                  height: "82%",
                  width: "50%",
                  borderRadius: "10px",
                  background: "#f3ce3f",
                  border: "2px solid #e6ca66",
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                  fontWeight: "bolder",
                }}
              >
                <RiDiscountPercentFill size={23} color="red" />
                <p
                  style={{ fontSize: "7px", padding: "4px", fontWeight: "700" }}
                >
                  Maximum usable cash bonus per trade = 5% of entry
                </p>
              </div>
            </div>

            <section style={{ width: "100%" }} className="ques">
              {realQuest?.length == 0 ? (
                <>
                  <h3 style={{ textAlign: "center", color: "grey" }}>
                    No questions for this match!
                  </h3>
                </>
              ) : (
                <></>
              )}
              {Array.isArray(realQuest) &&
                realQuest?.map((items, ind) => {
                  // console.log("items running",items);
                  return (
                    <div
                      style={{ borderWidth: 1, borderColor: "black" }}
                      className="question_box_"
                    >
                      <div
                        onClick={() =>
                          navigate(
                            `/placebetmarkets/${items?.match_id}/${items?.question_id}`
                          )
                        }
                        className="trade_rule"
                      >
                        <div className="trade_icon">
                          <img
                            style={{ height: "12px", width: "12px" }}
                            src={stock}
                            alt=""
                          />
                        </div>

                        <p style={{ fontSize: "11px" }}>
                          {items?.answer_count} traders {">"}{" "}
                        </p>
                      </div>
                      <div
                        onClick={() =>
                          navigate(
                            `/placebetmarkets/${items?.match_id}/${items?.question_id}`
                          )
                        }
                        className="imgque"
                      >
                        <div className="ques" style={{ width: "100%" }}>
                          <h5 style={{ fontWeight: "600", width: "100%" }}>
                            {items?.question_text}
                          </h5>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              columnGap: 5,
                              marginTop: 10,
                            }}
                            className="descpt"
                          >
                            <img
                              style={{
                                height: "20px",
                                width: "20px",
                                borderRadius: "50px",
                              }}
                              src={logo4}
                              alt=""
                            />
                            <p
                              style={{ fontSize: "11px" }}
                              className="shrt_desc"
                            >
                              {items?.question_short_desc}{" "}
                            </p>
                          </div>
                        </div>

                        <div
                          style={{ marginRight: "5px" }}
                          className="quest_img"
                        >
                          <img
                            style={{ borderRadius: "10px" }}
                            src={
                              items?.question_image == "" || null || undefined
                                ? logo4
                                : produc(items?.question_image)
                            }
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="yes_no_action">
                        <div
                          style={
                            {
                              // border: "1px solid #a6eaff",
                              // padding: "1px",
                            }
                          }
                        >
                          <button
                            onClick={() =>
                              setYes(
                                items?.match_id,
                                items?.question_id,
                                items?.option1_text
                              )
                            }
                            value={items?.option1_text}
                            style={{
                              fontWeight: "800",
                              width: "155px",
                              height: "35px",
                              fontSize: "12px",
                              letterSpacing: "0px",
                            }}
                            className="yes_btn"
                          >
                            {items.option1_text?.split(" ")?.length > 1
                              ? items?.option1_text?.split(" ")[0] + "..."
                              : items?.option1_text}{" "}
                            {items?.min_option1_amount == null
                              ? "₹ 5"
                              : "₹ " +
                                parseFloat(items?.min_option1_amount)}{" "}
                          </button>
                        </div>

                        <div
                          style={
                            {
                              // border: "1px solid #ffd0d0",
                              // padding: "1px",
                            }
                          }
                        >
                          <button
                            onClick={() =>
                              setNo(
                                items?.match_id,
                                items?.question_id,
                                items?.option2_text
                              )
                            }
                            value={items?.option2_text}
                            style={{
                              fontWeight: "800",
                              width: "155px",
                              height: "35px",
                              fontSize: "12px",
                              letterSpacing: "0px",
                            }}
                            className="no_btn"
                          >
                            {items.option2_text?.split(" ")?.length > 1
                              ? items?.option2_text?.split(" ")[0] + "..."
                              : items?.option2_text}{" "}
                            {items?.min_option1_amount == null
                              ? "₹ 5"
                              : "₹ " +
                                (10 - parseFloat(items?.min_option1_amount))}
                          </button>
                        </div>

                        <button
                          type="button"
                          className="btn btn-secondary tool"
                          data-toggle="tooltip"
                          data-placement="top"
                          style={{ borderRadius: 4, borderWidth: 1 }}
                        >
                          <div
                            style={{
                              // width: "50px",
                              height: "100%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                            onClick={() => infoPop(items, ind)}
                            className="qu_ic"
                          >
                            <FaInfo size={22} />
                          </div>
                        </button>
                      </div>
                    </div>
                  );
                })}
            </section>

            <section className="tbl">
              
            </section>

            
          </div>
        </div>
        {info && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "40vh",
              backgroundColor: "transparent", // Semi-transparent background
              zIndex: 999, // Ensure it's on top
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={(e) => {
              e.stopPropagation(); // Prevent event bubbling
              e.preventDefault(); // Block interaction with background
              setInfo((prev) => !prev); // Close the modal
            }}
          />
        )}
        <div style={{ position: "sticky", bottom: "0" }}>
          <div>
            {info && (
              <InfoPopup items={popinfo} close={setInfo} params={params} />
            )}
          </div>
          {info == true ? <></> : <Footer />}
        </div>

        <div className="Toastify"></div>
      </div>
    </div>
  );
}
